// src/runtime-config.js
export default async function loadRuntimeConfig() {
  try {
    // Path matches where config.json will live on the production server
    const res = await fetch('/alumni-system/frontend/config.json', { cache: 'no-store' });
    if (!res.ok) {
      console.warn('Runtime config not found (HTTP ' + res.status + ')');
      return {};
    }
    return await res.json();
  } catch (e) {
    console.warn('Error loading runtime config', e);
    return {};
  }
}
